// eventBus.js
import mitt from "mitt";

// Create a new instance of mitt
const bus = mitt();

export default bus;
